export const getPaymentDate = (payment) => {
  const rawDate =
    payment?.Date ??
    payment?.TransactionDate ??
    payment?.date ??
    payment?.transactionDate ??
    null;

  if (!rawDate) return null;
  const date = rawDate?.toDate ? rawDate.toDate() : new Date(rawDate);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const countSameDayPhoneDuplicates = ({
  pendingPayments,
  currentPaymentKey,
  phone,
  getPaymentKey,
  resolvePhoneNumber,
  resolveContext,
  now = new Date(),
}) => {
  if (
    !phone ||
    !Array.isArray(pendingPayments) ||
    typeof getPaymentKey !== "function" ||
    typeof resolvePhoneNumber !== "function"
  ) {
    return 0;
  }

  const dayStart = new Date(now);
  dayStart.setHours(0, 0, 0, 0);
  const dayEnd = new Date(dayStart);
  dayEnd.setHours(23, 59, 59, 999);

  return pendingPayments.reduce((count, pending) => {
    if (getPaymentKey(pending) === currentPaymentKey) return count;
    if (resolvePhoneNumber(pending, resolveContext) !== phone) return count;
    const pendingDate = getPaymentDate(pending);
    if (!pendingDate || pendingDate < dayStart || pendingDate > dayEnd) {
      return count;
    }
    return count + 1;
  }, 0);
};
